<template>
  <div v-if="loading" class="mt-5 text-center">
    <b-spinner
      class="mx-center"
      label="Loading..."
      variant="secondary"
    ></b-spinner>
  </div>
  <div v-else>
    <b-container class="my-4" fluid="lg">
      <b-row>
        <b-col>
          <h4>Thematic and format limits</h4>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-form-select v-model="thematicFormatSelected" :options="this.uniqueThematicFormat"
                         @change="updateLimits"></b-form-select>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-form-group
            label="Choose white/blacklist minimal visits limit:"
            label-align-sm="left"
            label-cols-sm="5"
          >
            <b-form-input
              id="input-min-wbl"
              v-model="wblMinEvents"
              placeholder="not set"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Choose exploration minimal visits limit:"
            label-align-sm="left"
            label-cols-sm="5"
          >
            <b-form-input
              id="input-min-explr"
              v-model="explrMinEvents"
              placeholder="not set"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Choose exploration maximum visits limit:"
            label-align-sm="left"
            label-cols-sm="5"
          >
            <b-form-input
              id="input-max-explr"
              v-model="explrMaxEvents"
              placeholder="not set"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-button
            variant="primary"
            @click="saveLimits">
            <b-icon v-if="!savingLimits" icon="archive"></b-icon>
            <b-spinner
              v-if="savingLimits"
              class="mx-center"
              label="Downloading..."
              small
              variant="outline-primary">
            </b-spinner>
            Update Limits
          </b-button>
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            @click="fetchData">
            <b-icon v-if="!savingLimits" icon="arrow-repeat"></b-icon>
            Refresh
          </b-button>
        </b-col>
        <b-col/>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-button variant="primary" @click="downloadCsv('whitelist')">
            <b-icon v-if="!csvDownloading" icon="cloud-download"></b-icon>
            <b-spinner
              v-if="csvDownloading"
              class="mx-center"
              label="Downloading..."
              small
              variant="outline-primary">
            </b-spinner>
            Download Whitelist Placements
          </b-button>
        </b-col>
        <b-col>
          <b-button variant="primary" @click="downloadCsv('blacklist')">
            <b-icon v-if="!csvDownloading" icon="cloud-download"></b-icon>
            <b-spinner
              v-if="csvDownloading"
              class="mx-center"
              label="Downloading..."
              small
              variant="outline-primary">
            </b-spinner>
            Download Blacklist Placements
          </b-button>
        </b-col>
        <b-col>
          <b-button variant="primary" @click="downloadCsv('exploration')">
            <b-icon v-if="!csvDownloading" icon="cloud-download"></b-icon>
            <b-spinner
              v-if="csvDownloading"
              class="mx-center"
              label="Downloading..."
              small
              variant="outline-primary">
            </b-spinner>
            Download Exploration Placements
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <div class="my-5" v-if="isAdminView()">
      <b-container fluid="lg">
        <b-row>
          <b-col>
            <b-button v-b-toggle.collapse-admin-debug variant="outline-primary">Show Admin Debug Data</b-button>
          </b-col>
        </b-row>
      </b-container>
      <b-collapse id="collapse-admin-debug" class="mt-2">
        <b-card>
          <p class="card-text">Admin Debug Data</p>
          <b-table
            class="mt-5 text-center table table-hover"
            ref="table"
            :fields="fields"
            :items="items"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            bordered
            hover
            responsive="md"
            selectable
            selected-variant="primary"
            show-empty
            small
            striped
            @sort-changed="sortChanged">
          </b-table>
        </b-card>
      </b-collapse>
    </div>
  </div>

</template>

<script>
import util from "../util/util"
import defaults from "../util/defaults"

export default {
  name: "Insights",
  data() {
    return {
      csvDownloading: false,
      savingLimits: false,
      loading: true,
      success: false,
      wblMinEvents: null,
      explrMinEvents: null,
      explrMaxEvents: null,
      maxEvents: 1000,
      suspCutoff: 0.0,
      ivtCutoff: 0.0,
      engCutoff: 0.0,
      items: [],
      fields: [],
      sortBy: "engagement_score",
      sortDesc: true,
      recsData: null,
      thematicFormatSelected: {thematic: "", format: ""},
      uniqueThematicFormat: [],
    };

  },
  methods: {
    isAdminView() {
      return (
        firebase.auth().currentUser.displayName === "admin"
      );
    },
    sortChanged(state) {
      this.sortBy = state.sortBy;
      this.sortDesc = state.sortDesc;
    },
    updateLimits() {
      this.wblMinEvents = null;
      this.explrMinEvents = null;
      this.explrMaxEvents = null;
      this.recsData['limits'].forEach(item => {
        if (item["thematic"] === this.thematicFormatSelected.thematic && item["format"] === this.thematicFormatSelected.format) {
          this.wblMinEvents = item.wbl_minVisits;
          this.explrMinEvents = item.explr_minVisits;
          this.explrMaxEvents = item.explr_maxVisits;
        }
      })
    },
    clearLimits() {
      this.thematicFormatSelected = {thematic: "", format: ""}
      this.wblMinEvents = null;
      this.explrMinEvents = null;
      this.explrMaxEvents = null;
    },
    async saveLimits() {
      const limits = {
        thematic: this.thematicFormatSelected.thematic,
        format: this.thematicFormatSelected.format,
        wbl_minVisits: this.wblMinEvents,
        explr_minVisits: this.explrMinEvents,
        explr_maxVisits: this.explrMaxEvents
      }

      this.savingLimits = true;

      let user = firebase.auth().currentUser;
      let token = await user.getIdToken().then((t) => t);

      fetch(
        process.env.VUE_APP_BASE_URL +
        "insights" +
        "?demo_uid=" +
        this.$store.getters.demoUid,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "JWT " + token,
          },
          body: JSON.stringify(limits),
        }
      ).then((response) => {
        if (!response.ok) {
          throw Error(response.body);
        }
        return response.text();
      }).catch((error) => {
        console.error("Error:", error);
      }).finally(() => {
        this.savingLimits = false
      });
    },
    async fetchData(ctx) {
      this.loading = true;
      this.success = false;
      this.clearLimits();
      this.items = [];
      this.fields = [];
      try {
        let paramMap = defaults.getParamMap.call(this, [defaults.PARAMS.demoUid, defaults.PARAMS.ab])
        this.recsData = await util.apiCall(process.env.VUE_APP_BASE_URL, defaults.ROUTES.insights, paramMap)
            .then((response) => response.json());

        this.uniqueThematicFormat = [];
        this.uniqueThematicFormat.push({
          value: {thematic: "", format: ""},
          text: 'Please select a thematic and format'
        });
        if (this.recsData["unique_thematic_format"]) {
          this.recsData["unique_thematic_format"].forEach(item => {
            this.uniqueThematicFormat.push({value: item, text: item.thematic + " | " + item.format});
          })
        }
        if (this.recsData.data && this.recsData.schema) {
          this.items = this.recsData.data;
          this.recsData.schema.forEach((element) => {
            this.fields.push({
              key: element,
              label: element,
              sortable: true,
              sortDirection: "desc",
            });
          });
        }
        this.success = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async downloadCsv(context) {
      this.csvDownloading = true;

      try {
        let csv = [];
        this.recsData[context].map(data => {
          if (data.thematic === this.thematicFormatSelected.thematic && data.format === this.thematicFormatSelected.format) {
            csv.push(data.placement);
          }
        });

        util.downloadFile(`seetrue.io-${context}-recommendation-export.csv"`, csv.join(","));
      } catch (error) {
        console.log(error);
      } finally {
        this.csvDownloading = false;
      }
    },
  },
  async created() {
    this.vuexUnsubscribe = this.$store.subscribe(async (mutation, state) => {
      if (mutation.type === "setDemoUid") {
        await this.fetchData("");
      }
    });

    await this.fetchData("");
  },
  beforeDestroy() {
    this.vuexUnsubscribe();
  },
}

</script>

<style scoped>
.table {
  font-size: 9px;
  overflow-x: scroll;
}

.bold {
  font-weight: bold;
}

.btn:focus {
  outline: none;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Insights.vue